import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://0b14af61135168003816afb42bf90ca5@o4506346036920320.ingest.sentry.io/4506363631370240',
    tracePropagationTargets: ['localhost', /\S*\.ailytics\.ai\S*/],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maxReplayDuration: 1000 * 30, // 30 seconds
        maskAllInputs: true,
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1, // 100% of errors
  });
};
